export const GetFormMixin = {
  methods: {
    setSuccessOrError(res) {
      if (res.status == 404) {
        this.notFoundErrorMessage = res.data;
        this.notFound = true;
      } else {
        this.isCreated = true;
      }
    }
  }
};
